module.exports = __webpack_public_path__ + "media/images/e-bilet/arrows_form-095f632b7dbe528ecbb7c7484deaa071.svg";